// import React from "react";
// import {
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell as MuiTableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Stack,
//   styled,
// } from "@mui/material";

// export type Project = {
//   srNo: number;
//   title: string;
//   studentName: string;
//   guideName: string;
//   yearOfCompletion: string;
// };

// const TableCell = styled(MuiTableCell)(({ theme }) => ({
//   textAlign: "left",
//   color: theme.palette.primary.contrastText,
// }));

// const ProjectList = ({ projects }: { projects: Project[] }) => {
//   return (
//     <Stack
//       direction="column"
//       alignItems="center"
//       justifyContent="center"
//       sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
//       spacing={2}
//     >
//       <Box sx={{ width: "90%", mt: 4, mx: "auto" }}>
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Sr No</TableCell>
//                 <TableCell>PROJECT TITLE</TableCell>
//                 <TableCell>STUDENT NAME</TableCell>
//                 <TableCell>GUIDE NAME</TableCell>
//                 <TableCell>YEAR OF COMPLETION</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {projects?.length > 0 ? (
//                 projects.map((project) => (
//                   <TableRow key={project.srNo}>
//                     <TableCell>{project.srNo}</TableCell>
//                     <TableCell>{project.title}</TableCell>
//                     <TableCell>{project.studentName}</TableCell>
//                     <TableCell>{project.guideName}</TableCell>
//                     <TableCell>{project.yearOfCompletion}</TableCell>
//                   </TableRow>
//                 ))
//               ) : (
//                 <TableRow sx={{ textAlign: "center" }}>
//                   <TableCell
//                     colSpan={5}
//                     align="center"
//                     style={{ textAlign: "center" }}
//                   >
//                     {"No data Found!"}
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Box>
//     </Stack>
//   );
// };

// export default ProjectList;

import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  styled,
} from "@mui/material";

export type Project = {
  srNo: number;
  title: string;
  studentName: string;
  guideName: string;
  yearOfCompletion: string;
};

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: 14,
  textAlign: "left",
  color: theme.palette.primary.contrastText,
}));

const ProjectList = ({ projects }: { projects: Project[] }) => {
  const titles = [
    "Sr No",
    "PROJECT TITLE",
    "STUDENT NAME",
    "GUIDE NAME",
    "YEAR OF COMPLETION",
  ];

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      spacing={2}
    >
      <Box sx={{ width: "90%", mt: 4, mx: "auto" }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "primary.main", color: "#fff" }}>
              <TableRow>
                {titles.map((title, index) => (
                  <TableCell key={index} sx={{ color: "#fff" }}>
                    {title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {projects?.length > 0 ? (
                projects.map((project) => (
                  <TableRow key={project.srNo}>
                    <TableCell>{project.srNo}</TableCell>
                    <TableCell>{project.title}</TableCell>
                    <TableCell>{project.studentName}</TableCell>
                    <TableCell>{project.guideName}</TableCell>
                    <TableCell>{project.yearOfCompletion}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={5}
                    align="center"
                    sx={{ textAlign: "center" }}
                  >
                    No data Found!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Stack>
  );
};

export default ProjectList;
